import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, NavigationEnd, Router} from '@angular/router';
import {FirestoreService} from '../../services/firestore.service';
import {SwiperConfigInterface} from 'ngx-swiper-wrapper';
import {Location} from '@angular/common';

@Component({
  selector: 'app-details',
  templateUrl: './details.component.html',
  styleUrls: ['./details.component.scss']
})
export class DetailsComponent implements OnInit {

  screenW = window.innerWidth;
  public swiperConfig: SwiperConfigInterface;
  lang;
  collection;
  id;
  title;
  data: any = [];

  constructor(public activatedRoute: ActivatedRoute, private fs: FirestoreService, public router: Router, public location: Location) {
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.data = [];
        this.lang = localStorage.getItem('lang');
        this.collection = this.activatedRoute.snapshot.paramMap.get('collection');
        this.id = this.activatedRoute.snapshot.paramMap.get('id');
          this.fs.getMenu(
            this.activatedRoute.snapshot.paramMap.get('collection'),
            this.activatedRoute.snapshot.paramMap.get('id'))
            .valueChanges().subscribe(data => {
            // @ts-ignore
            this.data = data;
          });
      }
    });
  }

  goBack() {
    this.location.back();
  }
  ngOnInit() {
    this.swiperConfig = {
      autoplay: true,
      slidesPerView: 1,
      pagination: true,
      spaceBetween: 0

    };
  }

}
